import React from 'react';
import { LoadingSpinner as OldLoadingSpinner } from '../../pages/Common/LoadingSpinner';

interface LoadingSpinnerProps {}

export default function LoadingSpinner({}: LoadingSpinnerProps) {
  return <OldLoadingSpinner color={'inherit'} />;
}
